export default __webpack_public_path__ + "static/media/arecanut-icon.e3cf7965.svg";